<template>
  <div class="code-boat-container" :class="{ 'is-home': navFuntions.active === 'home' }">
    <div class="code-boat">
      <!-- Duman Bulutları -->
      <div class="smoke-clouds">
        <span class="smoke sm1">{ }</span>
        <span class="smoke sm2">( )</span>
        <span class="smoke sm3">[ ]</span>
        <span class="smoke sm4">&lt;&gt;</span>
        <span class="smoke sm5">{ }</span>
      </div>
      
      <!-- Bacalar -->
      <div class="chimneys">
        <div class="chimney chimney-1">
          <span class="chimney-cap">▓▓▓</span>
          <span class="chimney-body">║█║</span>
          <span class="chimney-body">║█║</span>
          <span class="chimney-body">║█║</span>
        </div>
        <div class="chimney chimney-2">
          <span class="chimney-cap">▓▓</span>
          <span class="chimney-body">║║</span>
          <span class="chimney-body">║║</span>
        </div>
      </div>
      
      <!-- Üst Kabin / Köprü -->
      <div class="bridge">
        <span class="bridge-roof">╔═══════════════╗</span>
        <div class="bridge-body">
          <span>║</span>
          <span class="radar">◎</span>
          <span class="bridge-window">▣</span>
          <span class="captain">☺</span>
          <span class="bridge-window">▣</span>
          <span class="wheel">◎</span>
          <span>║</span>
        </div>
        <span class="bridge-floor">╚═══════════════╝</span>
      </div>
      
      <!-- Orta Kabin -->
      <div class="cabin">
        <span class="cabin-roof">╭───────────────────────╮</span>
        <div class="cabin-body">
          <span>│</span>
          <span class="cabin-window">◉</span>
          <span class="cabin-window">◉</span>
          <span class="door">▯</span>
          <span class="cabin-window">◉</span>
          <span class="cabin-window">◉</span>
          <span>│</span>
        </div>
        <span class="cabin-floor">╰───────────────────────╯</span>
      </div>
      
      <!-- Güverte -->
      <div class="deck">
        <span class="deck-rail">┌──────────────────────────────────┐</span>
        <div class="deck-items">
          <span>│</span>
          <span class="lifebuoy">◎</span>
          <span class="windows">◦◦◦◦◦◦◦◦◦◦◦◦</span>
          <span class="lifebuoy">◎</span>
          <span>│</span>
        </div>
        <span class="deck-floor">├──────────────────────────────────┤</span>
      </div>
      
      <!-- Ana Gövde -->
      <div class="hull-section">
        <div class="hull-row hull-1">╔══════════════════════════════════════╗</div>
        <div class="hull-row hull-2">║  ┌─────────────────────────────────┐ ║</div>
        <div class="hull-row hull-3">║  │  &lt;steam&gt; { power: 100 } &lt;/steam&gt; │ ║</div>
        <div class="hull-row hull-4">║  │    console.log("sailing...")    │ ║</div>
        <div class="hull-row hull-5">║  └─────────────────────────────────┘ ║</div>
        <div class="hull-row hull-6">╠══════════════════╦═══════════════════╣</div>
        <div class="hull-row hull-7">║  ⚓ CODERPIX ⚓  ║   ⛽ FUEL: ████   ║</div>
        <div class="hull-row hull-8">╚══════════════════╩═══════════════════╝</div>
      </div>
      
      <!-- Alt Kısım -->
      <div class="bottom">
        <span class="keel-left">╲</span>
        <span class="keel-line">═════════</span>
        <span class="propeller">⚙</span>
        <span class="keel-line">═════════</span>
        <span class="keel-right">╱</span>
      </div>
    </div>
    
    <!-- Su Efektleri -->
    <div class="water-effects">
      <span class="wave w1">~</span>
      <span class="wave w2">≈</span>
      <span class="wave w3">~</span>
      <span class="wave w4">≈</span>
      <span class="wave w5">~</span>
      <span class="wave w6">≈</span>
      <span class="wave w7">~</span>
    </div>
    
    <!-- Köpük İzi -->
    <div class="wake">
      <span class="bubble b1">°</span>
      <span class="bubble b2">•</span>
      <span class="bubble b3">°</span>
      <span class="bubble b4">•</span>
      <span class="bubble b5">°</span>
    </div>
  </div>
</template>

<script>
import { navFuntions } from "@/navFuntions";

export default {
  name: "BuoyComponent",
  data() {
    return {
      navFuntions
    };
  },
  computed: {
    isHomeActive() {
      return this.navFuntions.active === 'home';
    }
  }
};
</script>

<style scoped>
.code-boat-container {
  position: fixed;
  bottom: 85px;
  right: calc(50% - 280px);
  z-index: 5;
  animation: float-boat 6s ease-in-out infinite;
  /* Tüm özellikler için yumuşak geçiş */
  transition: all 1.2s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Home sayfası dışındayken gemiyi uzaklaştır */
.code-boat-container:not(.is-home) {
  right: -120px; /* Sağa kaydır */
  bottom: 40px; /* Aşağı indir */
  transform: scale(0.6) rotate(5deg); /* Küçült ve hafif döndür */
  opacity: 0.15; /* İyice silikleştir */
  filter: blur(3px); /* Bulanıklaştır (uzaklık hissi) */
  pointer-events: none; /* Tıklanmasını engelle */
}


.code-boat {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace;
  color: var(--main-color, #00D4BD);
  filter: drop-shadow(0 0 6px var(--main-color, #00D4BD));
  font-size: 10px;
  line-height: 1;
}

/* Duman */
.smoke-clouds {
  display: flex;
  gap: 8px;
  margin-bottom: 5px;
  height: 25px;
}

.smoke {
  color: #777;
  font-size: 9px;
  opacity: 0;
  animation: smoke-rise 4s ease-out infinite;
}

.sm1 { animation-delay: 0s; }
.sm2 { animation-delay: 0.8s; }
.sm3 { animation-delay: 1.6s; }
.sm4 { animation-delay: 2.4s; }
.sm5 { animation-delay: 3.2s; }

/* Bacalar */
.chimneys {
  display: flex;
  gap: 15px;
  align-items: flex-end;
}

.chimney {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 0.85;
}

.chimney-cap {
  color: #222;
  font-size: 9px;
}

.chimney-body {
  color: #8B0000;
  font-size: 10px;
}

.chimney-2 .chimney-body {
  color: #A52A2A;
  font-size: 9px;
}

/* Köprü */
.bridge {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -2px;
}

.bridge-roof {
  color: #4682B4;
  font-size: 9px;
}

.bridge-body {
  display: flex;
  color: #5F9EA0;
  font-size: 9px;
}

.bridge-floor {
  color: #4682B4;
  font-size: 9px;
}

.bridge-window {
  color: #87CEEB;
  margin: 0 2px;
}

.radar {
  color: #32CD32;
  animation: radar-spin 3s linear infinite;
  margin: 0 2px;
}

.wheel {
  color: #CD853F;
  margin: 0 2px;
}

.captain {
  color: #FFE4B5;
  font-size: 9px;
  margin: 0 3px;
}

/* Kabin */
.cabin {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -1px;
}

.cabin-roof {
  color: #CD853F;
  font-size: 9px;
}

.cabin-body {
  display: flex;
  color: #A0522D;
  font-size: 9px;
}

.cabin-floor {
  color: #8B4513;
  font-size: 9px;
}

.cabin-window {
  color: #FFD700;
  margin: 0 2px;
  animation: window-glow 2s ease-in-out infinite;
}

.door {
  color: #5D3A1A;
  margin: 0 3px;
}

/* Güverte */
.deck {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -1px;
}

.deck-rail {
  color: #CD853F;
  font-size: 9px;
}

.deck-items {
  display: flex;
  align-items: center;
  color: #CD853F;
  font-size: 8px;
}

.deck-floor {
  color: #A0522D;
  font-size: 9px;
}

.windows {
  color: #FFD700;
  margin: 0 3px;
  letter-spacing: 1px;
  animation: window-glow 2s ease-in-out infinite;
  animation-delay: 0.3s;
}

.lifebuoy {
  color: #FF6347;
  margin: 0 3px;
}

/* Gövde */
.hull-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -1px;
}

.hull-row {
  line-height: 0.95;
}

.hull-1, .hull-6, .hull-8 {
  font-size: 8px;
  color: #8B4513;
}

.hull-2, .hull-5 {
  font-size: 8px;
  color: #A0522D;
}

.hull-3 {
  font-size: 8px;
  color: #87CEEB;
}

.hull-4 {
  font-size: 8px;
  color: #98FB98;
}

.hull-7 {
  font-size: 8px;
  color: #DEB887;
}

/* Alt */
.bottom {
  display: flex;
  align-items: center;
  margin-top: -1px;
  font-size: 10px;
}

.keel-left, .keel-right {
  color: #5D3A1A;
}

.keel-line {
  color: #444;
  font-size: 8px;
}

.propeller {
  font-size: 14px;
  color: #666;
  margin: 0 3px;
  animation: propeller-spin 0.3s linear infinite;
}

/* Su Efektleri */
.water-effects {
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.wave {
  color: var(--main-color, #00D4BD);
  font-size: 12px;
  animation: wave-float 2s ease-in-out infinite;
  opacity: 0.7;
}

.w1 { animation-delay: 0s; }
.w2 { animation-delay: 0.12s; }
.w3 { animation-delay: 0.24s; }
.w4 { animation-delay: 0.36s; }
.w5 { animation-delay: 0.48s; }
.w6 { animation-delay: 0.6s; }
.w7 { animation-delay: 0.72s; }

/* Köpük */
.wake {
  position: absolute;
  bottom: 5px;
  right: -40px;
  display: flex;
  gap: 6px;
}

.bubble {
  color: #FFFFFF;
  font-size: 8px;
  opacity: 0;
  animation: bubble-trail 2s ease-out infinite;
}

.b1 { animation-delay: 0s; }
.b2 { animation-delay: 0.3s; }
.b3 { animation-delay: 0.6s; }
.b4 { animation-delay: 0.9s; }
.b5 { animation-delay: 1.2s; }

/* Animasyonlar */
@keyframes float-boat {
  0%, 100% {
    transform: translateY(0) rotate(-0.5deg);
  }
  30% {
    transform: translateY(-6px) rotate(1deg);
  }
  60% {
    transform: translateY(-3px) rotate(0deg);
  }
  80% {
    transform: translateY(-7px) rotate(0.5deg);
  }
}

@keyframes smoke-rise {
  0% {
    opacity: 0.7;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(-35px) scale(1.8);
  }
}

@keyframes window-glow {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; text-shadow: 0 0 8px #FFD700; }
}

@keyframes propeller-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes radar-spin {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}

@keyframes wave-float {
  0%, 100% { transform: translateY(0); opacity: 0.7; }
  50% { transform: translateY(-3px); opacity: 1; }
}

@keyframes bubble-trail {
  0% {
    opacity: 0.8;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(25px) translateY(-10px);
  }
}

/* Responsive */
@media (max-width: 1200px) {
  .code-boat-container {
    right: calc(50% - 220px);
    transform: scale(0.8);
  }
}

@media (max-width: 768px) {
  .code-boat-container {
    right: calc(50% - 140px);
    bottom: 70px;
    transform: scale(0.55);
  }
}
</style>
